module.exports = "/assets/data/315486e9faac9900bb3c3fffc9ebf0f6-WR11.data.json";